import * as React from 'react';
import { classNames, useUitkContext } from 'uitk-react-utils';
import { UitkRadioButtonGroupContext } from './uitk-radio-button-group-provider.esm.js';
import styles from './uitk-radio-button.css';

var getClassNameList = classNames.bind(styles);
var UitkRadioButtonGroup = function (props) {
    var children = props.children, className = props.className, defaultChecked = props.defaultChecked, errorMessage = props.errorMessage, group = props.group, legendLabel = props.legendLabel, selected = props.selected, onChange = props.onChange;
    var wrapperClassNames = getClassNameList('uitk-radio-button-group', className);
    var errorClassNames = getClassNameList('uitk-radio-button-error');
    var contextData = useUitkContext().data;
    var _a = contextData !== null && contextData !== void 0 ? contextData : {}, hasRequiredFieldIndicator = _a.hasRequiredFieldIndicator, collapsed = _a.collapsed, srMessage = _a.srMessage;
    var radioButtonGroupContextValue = React.useMemo(function () { return ({ onChange: onChange, defaultChecked: defaultChecked, group: group, selected: selected, hasRequiredFieldIndicator: hasRequiredFieldIndicator }); }, [onChange, defaultChecked, group, selected, hasRequiredFieldIndicator]);
    return (React.createElement("fieldset", { className: wrapperClassNames },
        React.createElement("legend", { className: "is-visually-hidden" },
            legendLabel || group,
            collapsed && (srMessage ? ". ".concat(srMessage) : '')),
        errorMessage && React.createElement("p", { className: errorClassNames }, errorMessage),
        React.createElement(UitkRadioButtonGroupContext.Provider, { value: radioButtonGroupContextValue }, children)));
};

export { UitkRadioButtonGroup };
